var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put } from "redux-saga/effects";
import { logError } from "../../logger/logger";
import { getGetDetailAction } from "./detail.actions";
export var getGetDetailSaga = function (params) {
    var entityName = params.entityName, getDetail = params.getDetail;
    var routine = getGetDetailAction({ entityName: entityName });
    function sagaStartFlow(_a) {
        var id, filter, onSuccess, data, unknownError_1, error;
        var payload = _a.payload;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    id = payload.id, filter = payload.filter, onSuccess = payload.onSuccess;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 6]);
                    return [4 /*yield*/, call(getDetail, {
                            id: id,
                            filter: filter,
                        })];
                case 2:
                    data = (_b.sent()).data;
                    return [4 /*yield*/, put(routine.actions.success({
                            data: data,
                        }))];
                case 3:
                    _b.sent();
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data);
                    return [3 /*break*/, 6];
                case 4:
                    unknownError_1 = _b.sent();
                    error = unknownError_1;
                    logError({ error: error });
                    return [4 /*yield*/, put(routine.actions.failure({
                            id: id,
                            error: error,
                        }))];
                case 5:
                    _b.sent();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }
    return sagaStartFlow;
};
